export class AuthConstants {

    public static AUTH_ENDPOINT = "/provider/auth";
    public static LOGIN_URL = "/login";
    public static LOGOUT_URL = "/logout";
    public static SERVER_URL = "SERVER_URL";
    public static PUBLIC_ENDPOINT = "/ws/public/rest";
    public static START_IMPERSONATION_ENDPOINT = "/login/impersonate";
    public static EXIT_IMPERSONATION_ENDPOINT = "/logout/impersonate";
    public static PAGE_LOGIN = "/ws/public/rest/getPageLogin/";
    public static DEFAULT_CODE_DELAY = 30;
}
